import { Input, Button, Divider, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import UploadSvg from '../../assets/images/uploadSvg';
import { SearchOutlined } from '@ant-design/icons';

const EducationCourseHeaderTeacher = ({
    setViewType, setModalOpen,
    modalOpen, dates, setDates,
    loading, setTableParams, setLoading,
    tableParams, initLoadMagazine,
    setKeyword, keyword, messageModalRef,
    teacherId
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <>
            <Row className='d-flex align-items-center mt-4'>
                <Col md={17}
                    style={{ display: 'flex', justifyContent: "space-between" }}
                >
                    <Input
                        placeholder={t("Search")}
                        style={{ width: "40%" }}
                        size="large"
                        disabled={loading}
                        loading={loading}
                        prefix={
                            <SearchOutlined
                                style={{
                                    color: '#8c8c8c',
                                    cursor: "pointer",
                                    opacity: "0.4"
                                }}
                            />
                        }
                        className="me-4"
                        allowClear
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                    />
                </Col>
                <Col md={7} style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                    <Button
                        size="large"
                        style={{marginRight:"1rem"}}
                        onClick={() => {
                            setTableParams({
                                ...tableParams,
                                pagination: {
                                    ...tableParams.pagination,
                                    current: 1,
                                },
                            });
                            initLoadMagazine();
                        }}
                    >
                        {t('Query')}
                    </Button>
                    <Divider type="vertical" style={{ height: '24px', borderColor: '#d9d9d9', paddingLeft:"1rem" }} />
                    <div className='d-flex align-items-center'>
                        <Button
                            icon={<UploadSvg />}
                            onClick={() => navigate(`/education-course/upload?id=${teacherId}`)}
                            style={{
                                fontSize: '16px',
                                backgroundColor: "#F8E2E8",
                                border: "none",
                                color: "#E50A47"
                            }}
                            danger
                        >
                            {t('Upload video')}
                        </Button>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default EducationCourseHeaderTeacher;
